/**
 * Brazilian state (UF) codes — the location facet granularity for marketplace
 * offers. A single indexed `regionCode` on the offer; lat/long radius is
 * deferred. Order is the conventional alphabetical UF listing.
 */
export const BR_STATES = [
    "AC",
    "AL",
    "AP",
    "AM",
    "BA",
    "CE",
    "DF",
    "ES",
    "GO",
    "MA",
    "MT",
    "MS",
    "MG",
    "PA",
    "PB",
    "PR",
    "PE",
    "PI",
    "RJ",
    "RN",
    "RS",
    "RO",
    "RR",
    "SC",
    "SP",
    "SE",
    "TO",
];
/** Type guard: is `value` a valid Brazilian state code? */
export function isBrazilState(value) {
    return BR_STATES.includes(value);
}
//# sourceMappingURL=Geography.js.map